<template>
  <!-- 答题 -->
  <div class="vote">
    <div class="votediv">
      <div class="vote-line"></div>
      <div class="vote-close"></div>
      <div id="vote1">
        <div class="vote-icon"></div>
        <h3>请选择答案</h3>
        <div class="vote-tips">题干部分请参考文档或直播视频</div>
        <ul class="vote-option"></ul>
      </div>
      <div id="vote2">
        <div class="vote-icon2"></div>
        <h3>答题统计</h3>
        <div class="vote-tips">
          答题结束，共<span id="vote-count"></span>人回答。
        </div>
        <div class="vote-a">
          <span id="yansw">您的答案:<em></em></span>
          <span
            id="cansw"
            class="vote-righta"
          >正确答案:<em></em></span>
        </div>
        <ul class="vote-list"></ul>
      </div>
    </div>
    <div class="maskbg"></div>
  </div>
</template>

<script>
export default {
  methods: {},
  created() { },
  mounted() {
    // 答题
    var option = ''
    window.voteOptions = []
    DWLive.onStartVote = function (data) {
      option = ''
      window.voteOptions = []

      var voteid = data.voteId
      var pid = data.publisherId
      var count = data.voteCount
      var voteType = data.voteType

      if (count == 5) {
        $('.vote-option').append('<li>A<span></span></li><li>B<span></span></li><li>C<span></span></li><li>D<span></span></li><li>E<span></span></li>')
        $('#vote1').append('<div class="votebtn"><button>提交</button></div>')
      }
      if (count == 4) {
        $('.vote-option').append('<li>A<span></span></li><li>B<span></span></li><li>C<span></span></li><li>D<span></span></li>')
        $('#vote1').append('<div class="votebtn"><button>提交</button></div>')
      }
      if (count == 3) {
        $('.vote-option').append('<li>A<span></span></li><li>B<span></span></li><li>C<span></span></li>')
        $('#vote1').append('<div class="votebtn"><button>提交</button></div>')
      }
      if (count == 2) {
        $('.vote-option').append('<li>A<span></span></li><li>B<span></span></li>')
        $('.vote-option li').eq(0).addClass('vote-r')
        $('.vote-option li').eq(1).addClass('vote-w')
        $('#vote1').append('<div class="votebtn"><button>提交</button></div>')
      }
      $('.vote-option li:last-child').addClass('last-item')
      $('.vote').show()
      $('#vote1').show()
      $('#vote2').hide()
      $('.vote-list').empty()
      $('.video-box').css({ 'width': 1, 'height': 1 })

      $('.vote-option li').click(function () {
        var index = $('.vote-option li').index(this)

        if (voteType == 1) { // 多选题
          if ($(this).hasClass('active')) {
            $(this).removeClass('active')
          } else {
            $(this).addClass('active')
          }

          window.voteOptions = []
          $('.vote-option li').each(function (index, data) {
            if ($(data).hasClass('active')) {
              window.voteOptions.push(index)
            }
          })
        } else {
          $(this).addClass('active').siblings().removeClass('active')
        }

        $('.votebtn button').css('opacity', 1)
        option = index
      })
      $('.votebtn button').click(function () {
        if ($('.vote-option li').hasClass('active')) {
          var j = {
            'voteId': voteid,
            'publisherId': pid
          }

          if (voteType == 1) { // 多选题
            j.voteOption = voteOptions
          } else {
            j.voteOption = option
          }

          DWLive.replyVote(voteid, j.voteOption, pid)

          $('.vote').hide()
          $('.vote-option').empty()
          $('.votebtn button').css('opacity', 0.6)
          $('.video-box').css({ 'width': '100%', 'height': '100%' })
          if ($('.mask').is(':visible')) {
            $('.video-box').css({ 'width': 1, 'height': 1 })
          }
          $('.votebtn').remove()
        }
      })
      $('.vote-close').click(function () {
        $('.vote').hide()
        $('.vote-option, .vote-list').empty()
        $('.votebtn button').css('opacity', 0.6)
        $('.video-box').css({ 'width': '100%', 'height': '100%' })
        if ($('.mask').is(':visible')) {
          $('.video-box').css({ 'width': 1, 'height': 1 })
        }
        option = ''
        window.voteOptions = []
        $('.votebtn').remove()
      })
    }

    // 结束答题
    DWLive.onStopVote = function () {
      $('.vote').hide()
      $('.vote-option, .vote-list').empty()
      $('.votebtn button').css('opacity', 0.6)
      $('.video-box').css({ 'width': '100%', 'height': '100%' })
      if ($('.mask').is(':visible')) {
        $('.video-box').css({ 'width': 1, 'height': 1 })
      }
      $('.votebtn').remove()
    }

    // 答题统计
    DWLive.onVoteResult = function (data) {
      // 选项个数
      var count = data.voteCount
      // 正确答案 数字或者数组
      var coption = data.correctOption
      // 多选题目
      var isMultiple = !((typeof coption) === 'number')
      // 判断题目
      var isJudge = count == 2

      var statisics = data.statisics
      var zcount = ''

      // 总回答人数
      var answerCount = data.answerCount

      // 正确内容
      var correctAnswer = ''
      var selfAnswer = ''

      if (isMultiple) {
        var ccs = []
        $.each(coption, function (index, o) {
          if (o >= 0 && o < 26) {
            ccs.push(String.fromCharCode(65 + o))
          }
        })
        correctAnswer = ccs.join(',')

        var ccs2 = []
        $.each(voteOptions, function (index, o) {
          if (o >= 0 && o < 26) {
            ccs2.push(String.fromCharCode(65 + o))
          }
        })
        selfAnswer = ccs2.join(',')
      } else if (isJudge) {
        if (coption == 0) {
          correctAnswer = '<i class="vote-ricon"></i>'
        } else if (coption == 1) {
          correctAnswer = '<i class="vote-wicon"></i>'
        }

        if ($.isNumeric(option) && option == 0) {
          selfAnswer = '<i class="vote-ricon"></i>'
        } else if ($.isNumeric(option) && option == 1) {
          selfAnswer = '<i class="vote-wicon"></i>'
        }
      } else {
        if ($.isNumeric(coption) && coption >= 0 && coption < 26) {
          correctAnswer = String.fromCharCode(65 + coption)
        }
        if ($.isNumeric(option) && option >= 0 && option < 26) {
          selfAnswer = String.fromCharCode(65 + option)
        }
      }

      switch (count) {
        case 2:
          var li = '<li>'
            + '<span class="spanl">√:</span>'
            + '<div class="vote-bar">'
            + '<div class="vote-in"></div>'
            + '</div>'
            + '<span class="color1">' + statisics[0].count + '人</span>'
            + '<span>(' + statisics[0].percent + '%)</span>'
            + '</li>'
            + '<li class="last-item">'
            + '<span class="spanl">X:</span>'
            + '<div class="vote-bar">'
            + '<div class="vote-in"></div>'
            + '</div>'
            + '<span class="color1">' + statisics[1].count + '人</span>'
            + '<span>(' + statisics[1].percent + '%)</span>'
            + '</li>'
          $('.vote-list').append(li)
          zcount = statisics[0].count + statisics[1].count
          break
        case 3:
          var li = '<li>'
            + '<span class="spanl">A:</span>'
            + '<div class="vote-bar">'
            + '<div class="vote-in"></div>'
            + '</div>'
            + '<span class="color1">' + statisics[0].count + '人</span>'
            + '<span>(' + statisics[0].percent + '%)</span>'
            + '</li>'
            + '<li>'
            + '<span class="spanl">B:</span>'
            + '<div class="vote-bar">'
            + '<div class="vote-in"></div>'
            + '</div>'
            + '<span class="color1">' + statisics[1].count + '人</span>'
            + '<span>(' + statisics[1].percent + '%)</span>'
            + '</li>'
            + '<li class="last-item">'
            + '<span class="spanl">C:</span>'
            + '<div class="vote-bar">'
            + '<div class="vote-in"></div>'
            + '</div>'
            + '<span class="color1">' + statisics[2].count + '人</span>'
            + '<span>(' + statisics[2].percent + '%)</span>'
            + '</li>'
          $('.vote-list').append(li)
          zcount = statisics[0].count + statisics[1].count + statisics[2].count
          break
        case 4:
          var li = '<li>'
            + '<span class="spanl">A:</span>'
            + '<div class="vote-bar">'
            + '<div class="vote-in"></div>'
            + '</div>'
            + '<span class="color1">' + statisics[0].count + '人</span>'
            + '<span>(' + statisics[0].percent + '%)</span>'
            + '</li>'
            + '<li>'
            + '<span class="spanl">B:</span>'
            + '<div class="vote-bar">'
            + '<div class="vote-in"></div>'
            + '</div>'
            + '<span class="color1">' + statisics[1].count + '人</span>'
            + '<span>(' + statisics[1].percent + '%)</span>'
            + '</li>'
            + '<li>'
            + '<span class="spanl">C:</span>'
            + '<div class="vote-bar">'
            + '<div class="vote-in"></div>'
            + '</div>'
            + '<span class="color1">' + statisics[2].count + '人</span>'
            + '<span>(' + statisics[2].percent + '%)</span>'
            + '</li>'
            + '<li class="last-item">'
            + '<span class="spanl">D:</span>'
            + '<div class="vote-bar">'
            + '<div class="vote-in"></div>'
            + '</div>'
            + '<span class="color1">' + statisics[3].count + '人</span>'
            + '<span>(' + statisics[3].percent + '%)</span>'
            + '</li>'
          $('.vote-list').append(li)
          zcount = statisics[0].count + statisics[1].count + statisics[2].count + statisics[3].count
          break
        case 5:
          var li = '<li>'
            + '<span class="spanl">A:</span>'
            + '<div class="vote-bar">'
            + '<div class="vote-in"></div>'
            + '</div>'
            + '<span class="color1">' + statisics[0].count + '人</span>'
            + '<span>(' + statisics[0].percent + '%)</span>'
            + '</li>'
            + '<li>'
            + '<span class="spanl">B:</span>'
            + '<div class="vote-bar">'
            + '<div class="vote-in"></div>'
            + '</div>'
            + '<span class="color1">' + statisics[1].count + '人</span>'
            + '<span>(' + statisics[1].percent + '%)</span>'
            + '</li>'
            + '<li>'
            + '<span class="spanl">C:</span>'
            + '<div class="vote-bar">'
            + '<div class="vote-in"></div>'
            + '</div>'
            + '<span class="color1">' + statisics[2].count + '人</span>'
            + '<span>(' + statisics[2].percent + '%)</span>'
            + '</li>'
            + '<li>'
            + '<span class="spanl">D:</span>'
            + '<div class="vote-bar">'
            + '<div class="vote-in"></div>'
            + '</div>'
            + '<span class="color1">' + statisics[3].count + '人</span>'
            + '<span>(' + statisics[3].percent + '%)</span>'
            + '</li>'
            + '<li class="last-item">'
            + '<span class="spanl">E:</span>'
            + '<div class="vote-bar">'
            + '<div class="vote-in"></div>'
            + '</div>'
            + '<span class="color1">' + statisics[4].count + '人</span>'
            + '<span>(' + statisics[4].percent + '%)</span>'
            + '</li>'
          $('.vote-list').append(li)
          zcount = statisics[0].count + statisics[1].count + statisics[2].count + statisics[3].count + statisics[4].count
          break
      }
      for (var i = 0; i < statisics.length; i++) {
        $('.vote-in').eq(i).css('width', statisics[i].percent + "%")
      }


      if (isMultiple) {
        // 为了兼容老客户端，单选题和判断的回答人数扔计算得出
        zcount = answerCount
      }

      $('#vote-count').html(zcount)
      // 自己选择的答案
      $('#yansw em').html(selfAnswer)
      // 正确答案
      $('#cansw em').html(correctAnswer)
      if ($('#yansw em').html() == $('#cansw em').html()) {
        $('#yansw').addClass('vote-righta')
      } else {
        $('#yansw').removeClass('vote-righta')
      }
      $('.vote').show()
      $('#vote2').show()
      $('#vote1').hide()
      $('.votebtn').remove()
      $('.video-box').css({ 'width': 1, 'height': 1 })
      option = ''
      window.voteOptions = []
      $('.vote-close').click(function () {
        $('.vote').hide()
        $('.vote-list').empty()
        $('.video-box').css({ 'width': '100%', 'height': '100%' })
        if ($('.mask').is(':visible')) {
          $('.video-box').css({ 'width': 1, 'height': 1 })
        }
        option = ''
        window.voteOptions = []
      })
    }

  },
};
</script>
